import LazyImg from '@/components/lazy-img';
import { Image } from '@/types';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Rotate, Slide } from 'react-awesome-reveal';
import { useTranslation } from 'react-i18next';

export default function Photos() {
    const { t } = useTranslation();

    const rotations = ['rotate-2', '-rotate-2'];
    const [images, setImages] = useState<Image[]>([]);

    const getImages = async (type: string): Promise<Array<Image>> => {
        return await (await fetch(route('assets.show', type))).json();
    };

    useEffect(() => {
        Promise.all([getImages('cat'), getImages('mountain'), getImages('other'), getImages('travel')])
            .then((response) => {
                setImages(_.sampleSize(response[0].concat(response[1], response[2], response[3]), 5));
            })
            .catch(() => setImages([]));
    }, []);

    return (
        <div className="mt-16 sm:mt-20">
            <Slide direction="up" triggerOnce>
                <div className="-my-4 flex justify-center gap-5 overflow-hidden py-4 sm:gap-8">
                    <Rotate triggerOnce cascade damping={0.2}>
                        {images.map((image, i) => (
                            <div
                                key={i}
                                className={`aspect-1 relative w-44 flex-none overflow-hidden rounded-xl bg-zinc-100 sm:w-72 sm:rounded-2xl dark:bg-zinc-800 ${_.sample(rotations)}`}
                            >
                                <LazyImg
                                    width={300}
                                    height={300}
                                    image={`/assets/${image.path}`}
                                    preImage={`/assets/${image.path}`}
                                    className="absolute inset-0 h-full w-full object-cover"
                                    forceLoad
                                    alt={t('img-alt.photo', { photo: i + 1 })}
                                    title={t('img-alt.photo', { photo: i + 1 })}
                                />
                            </div>
                        ))}
                    </Rotate>
                </div>
            </Slide>
        </div>
    );
}
